import React  from 'react';
import PropTypes from 'prop-types';

export const StdCourseGroup = ({ groupTitle, children, width }) => (
  <div style={{maxWidth: width}}>
    <h5
      style={{
        fontSize: 20,
        color: 'grey',
        whiteSpace: 'nowrap',
        marginTop: 20,
        marginBottom: 10
      }}>
      {groupTitle}
    </h5>
    <ul style={{padding:0, margin:0, marginTop: 5}}>
      {children}
    </ul>
  </div>
);

StdCourseGroup.propTypes = {
  groupTitle: PropTypes.string.isRequired,
  width: PropTypes.any
};



/** WEBPACK FOOTER **
 ** ./components/race/create/AddCourses/StdCourseGroup.js
 **/